import React, { FC } from 'react';
import cx from 'classnames';
import useThemeBlock from '@/hooks/useThemeBlock';
import block from './block.json';
// styles
import { getStyles } from './styles.css';

/**
 * TYPINGS
 */
export type IntroductionProps = {
	content: string;
} & ThemeProps;

/**
 * COMPONENT
 */
export const Introduction: FC<IntroductionProps> & BlockConfigs = ({
	content,
	theme = {},
}) => {
	const { variant, blockTheme } = useThemeBlock(block.slug, theme);

	const htmlProps = {
		'data-variant': variant,
	};

	const rootClass = cx('supt-introduction', getStyles(blockTheme));

	return (
		<p
			className={rootClass}
			dangerouslySetInnerHTML={{ __html: content }}
			data-block={block.slug}
			{...htmlProps}
		/>
	);
};

Introduction.slug = block.slug;
Introduction.title = block.title;
